import { Navigate, useParams, useSearchParams } from 'react-router-dom'
import { withSinglePage } from '@/shared/lib/single-page-link'

// /unsubscribe-feedback/:id — the retired cancel flow's URL. Native apps and old
// emails still deep-link to it, so it stays as a redirect to the cancel flow,
// preserving the singlePage (locked) mode.
export function UnsubscribeFeedbackRedirect() {
  const { subscriptionId } = useParams<{ subscriptionId: string }>()
  const [searchParams] = useSearchParams()
  const singlePage = searchParams.get('singlePage') === 'true'
  return (
    <Navigate
      to={withSinglePage(`/cancel-subscription/${subscriptionId}`, singlePage)}
      replace
    />
  )
}
